import { httpClient } from '../httpClient/httpClient';

export interface ClientConfiguration {
  hostEnvironment: string;
  rudholmIdentityEnabled: boolean;
}

export const clientConfigurationApi = {
  get: () => httpClient.get<ClientConfiguration>('public/client-configuration'),
};
